import { GIFTING_PATH } from 'lib/gifting/path';

export const START_ULTRAMETABOLIC_LINK = 'https://ultrahuman.com/pricing/';

export const AE_TYPEFORM_LINK = 'https://form.typeform.com/to/pdoXraa7';

export const PRICING_LINK = 'https://ultrahuman.com/pricing/';

export const PRICING_LINK_PATH = '/pricing/';

export const REFERRAL_PRICING_LINK_PATH = '/pricing-referral/';

export const AE_PRICING_LINK_ABSOLUTE = 'https://www.ultrahuman.com/ae/pricing';

export const BLOG_LINK = 'https://ultrahuman.com/blog';

export const READ_THE_SCIENCE_LINK =
  'https://ultrahuman.com/blog/what-is-metabolic-fitness?utm_source=affiliate_homepage_blogs&utm_medium=carousel&utm_content=wimf';

export const READ_THE_SCIENCE_LINK_METABOLIC_SCORE =
  'https://ultrahuman.com/blog?utm_source=affiliate_homepage_blogs&utm_medium=value_prop_section&utm_content=bh1';

export const READ_THE_SCIENCE_LINK_ACTIVITY_NUDGES =
  'https://ultrahuman.com/blog?utm_source=affiliate_homepage_blogs&utm_medium=value_prop_section&utm_content=bh2';

export const READ_THE_SCIENCE_LINK_FITNESS_INGIGHTS =
  'https://ultrahuman.com/blog/what-is-metabolic-fitness?utm_source=affiliate_homepage_blogs&utm_medium=value_prop_section&utm_content=wimf';

export const READ_THE_SCIENCE_LINK_FUEL =
  'https://ultrahuman.com/blog?utm_source=affiliate_homepage_blogs&utm_medium=value_prop_section&utm_content=bh3';

export const BOOK_CALL_LINK =
  'https://form.typeform.com/to/yOi1E7Wy?utm_source=web';

export const BOOK_CALL_LINK_RING =
  'https://form.typeform.com/to/u8LFDdZ2?utm_source=main-web';

export const AFFILIATE_TYPEFORM = 'https://form.typeform.com/to/ow2iKEHv';

export const NO_HEADER_OR_FOOTER_PAGES = [
  '/advanced',
  '/prompt',
  '/one-tree-planted',
  '/cycle-report',
  // Standalone partner serviceability tool — no site chrome.
  '/blood-vision/serviceability-check',
  // Full-bleed interactive micro-experience — no site chrome.
  '/emerald-sphere',
  // Hidden hiring easter egg. It also sets liteUI, but that is client-only, so
  // the nav and footer flashed in and out before hydration.
  '/window-of-opportunity',
  // main hides chrome on these via `useGlobalUI({ liteUI: true })` in the page
  // body. Listing them here is the same outcome without main's flash of chrome,
  // since this is evaluated during SSR rather than after hydration.
  '/ring/buy/better-help',
  '/troubleshoot',
  '/update-app',
  '/forms/heroes-special-pricing',
  '/forms/metabolic-health-assessment',
  '/gift-card/success',
  '/ring/order/success',
  '/ring/claim/status',
  '/ring-pro/claim/status',
  // QR-only event lead-capture form — standalone, no site chrome.
  '/ultra-network',
];

// Runtime paths carry real values (was the '/cycle-report/[token]' template):
// cycle-report matches by prefix, the other entries stay exact-match.
export const isNoHeaderOrFooterPage = (pathname: string): boolean =>
  NO_HEADER_OR_FOOTER_PAGES.includes(pathname) ||
  pathname.startsWith('/cycle-report/');

// Any order page (`/order/*`) is a standalone confirmation/tracking view — no
// site header or footer. Checked against `router.pathname` (the Next route
// pattern) so it works during SSR, unlike the client-only `liteUI` flag. The
// trailing slash avoids catching siblings like `/orders`.
export const isOrderPage = (pathname?: string): boolean =>
  pathname === '/order' || !!pathname?.startsWith('/order/');

// Pages that neither show the cookie-consent banner NOR load tracking scripts,
// regardless of any prior site-wide consent. Matched on the internal pathname.
// (Emerald is a standalone campaign micro-experience — see its README.)
export const NO_COOKIE_TRACKING_PAGES = ['/emerald-sphere'];

export const NO_FOOTER_PAGES = ['/forms/metabolic-health-assessment'];

export const NO_SUBSCRIBE_NOW_BUTTON_PAGES = ['/ae', '/ring', '/m1'];

export const NO_WA_CHATBOT_PAGES: Array<string> = [
  '/ring/claim',
  '/ring-pro/claim',
  '/ring/order',
  '/order',
  '/one-tree-planted',
  '/glucose',
  '/cycle-report',
  '/blood-vision/buy',
  '/performance-lab',
  // Full-bleed interactive micro-experience — no floating chat widget.
  '/emerald-sphere',
  // QR-only event lead-capture form.
  '/ultra-network',
];

export const WA_CHATBOT_ALTERNATE_MOBILE_UI_PAGES = [
  '/ring/buy',
  '/ring/buy/*',
  '/rare/buy',
  '/rare/buy/*',
  '/home/buy',
  '/home/buy/*',
  '/pricing',
  '/pricing/*',
  '/x/redeem',
  '/powerplugs/redeem',
  '/blood-vision/buy',
  '/blood-vision/buy/*',
  '/performance-lab/buy',
  GIFTING_PATH,
];

export const WA_CHATBOT_ALTERNATE_MOBILE_UI_EXCEPTIONS = [
  '/blood-vision/buy/blood-on-us',
];

export const HEADER_CART_ICON_IN_ACTIVE_PAGES: Array<string | never> = [
  // '/ring/buy/in',
  // '/ring/buy/ae',
  // '/ring/buy/us',
];

//check later
export const HEADER_NO_SHOPNOW_PATTERNS = [
  '/ring/buy/*',
  '/ring/buy',
  '/ring-pro/buy',
  '/ring-pro/buy/*',
  '/shop/*',

  '/sizing-kit',

  '/blood-vision',
  '/blood-vision/buy/*',
  '/blood-vision/buy',
  '/blood-vision/tests',

  '/pricing/*',
  '/pricing',

  '/home/',
  '/home/buy/*',
  '/home/buy',

  '/x/*',

  '/ogdb',
  '/ogdb/search',

  '/rare',
  '/rare/buy/*',
  '/rare/buy',
  '/diesel-ultrahuman-ring/buy/*',
  '/diesel-ultrahuman-ring/buy',
  '/heroes',

  '/performance-lab',
  '/performance-lab/*',
];

// export const HEADER_NO_SHOPNOW_PATTERNS = [
//   /^\/(home|ring\/buy\/[^/]+|products\/[^/]+|blood-vision|sizing-kit|blood-vision\/tests|environment|ogdb|ogdb\/search|pricing\/[^/]+)$/,
// ];

export const WA_POPUP_BY_PAGE_CONFIGS = {
  '/m1': {
    triggerDelay: 10,
  },
  '/pricing': {
    triggerDelay: 10,
  },
};
export const WA_POPUP_ACTIVE_PAGES = [...Object.keys(WA_POPUP_BY_PAGE_CONFIGS)];

export const NO_CART_UPSELL_PAGES = ['/pricing/recommended'];

// = = = = = = V2 things = = = = = = =

export const headerThemeConfig: Record<string, 'dark' | 'light'> = {
  // The homepage hero (RingProHero) is light beige at every breakpoint, so the
  // header text is dark. `/` is also in OPAQUE_LIGHT_BAR_ROUTES (Header.tsx),
  // which paints the unscrolled desktop bar opaque white — a campaign hero can
  // lead the page instead, and #111 labels straight over it are unreadable.
  '/': 'light',
  '/home': 'light',
  '/ring/buy': 'light',
  '/ring/buy/better-help': 'light',
  '/home/buy': 'light',
  '/home/buy/better-help': 'light',
  // The /science landing opens on a FULL-BLEED sky hero (Figma 1074:11780) with
  // the white dark-theme nav over the photo, so its first paint is dark.
  // science-client then flips the header to light once the hero scrolls out
  // (GlobalUI.headerThemeOverride). Exact path only — the key must stay: it also
  // feeds HEADER_FOOTER_V2_PAGES. The reading surfaces (studies, explainers,
  // accuracy) stay in FORCE_LIGHT_HEADER_ROUTE_PREFIXES; /science/ask stays dark.
  '/science': 'dark',
  // Light-hero routes that used to fall through to the dark default and painted
  // white text over a light hero. Verified per page: ring-pro #fff,
  // heroes #f0f0f0.
  '/ring-pro': 'light',
  '/heroes': 'light',
  // Flat-white pages, likewise previously white-on-white.
  '/choose-country-region': 'light',
  '/join_group': 'light',
  '/timeout': 'light',
  '/troubleshoot': 'light',
  '/birthday': 'light',
  '/investorRelations': 'light',
  '/partners': 'light',
  '/ring/pro-vs-air': 'light',
  '/ring/reviews': 'light',
  '/security': 'light',
  '/security/vulnerability-disclosure-policy': 'light',
  '/termsOfSale/UltrahumanR1': 'light',
  '/procharger-EUDOC': 'light',
  '/ringpro-EUDOC': 'light',
  '/legal/notice-march-2026': 'light',
  '/rare/buy': 'light',
  '/performance-lab/leaderboard': 'light',
  '/performance-lab/partner-with-us': 'light',
  '/blood-vision/buy': 'light',
  // India checkout (user details + slot booking) is a flat #f3f3f3 page.
  // Without this entry the header falls through to the dark default — white
  // labels on a light canvas, readable only after the scrolled frost lands.
  '/blood-vision/buy/checkout': 'light',
  '/x/redeem': 'light',
  '/retail': 'light',
  '/for-work': 'light',
  '/ring/faq': 'dark',
  '/ring-pro/faq': 'dark',
  '/shop': 'light',
  '/blood-vision/tests': 'light',
  '/blood-vision': 'dark',
  '/print-sizing-kit': 'dark',
  '/blood-vision/faq': 'dark',
  '/environment': 'light',
  '/ogdb': 'dark',
  '/ogdb/search': 'dark',
  '/powerplugs': 'dark',
  '/hsa-fsa': 'light',
  '/performance-lab/buy': 'light',
  '/photon': 'light',
  '/photon/buy': 'light',
  // Native legal pages render on a white background — keep the header light.
  '/privacyPolicy': 'light',
  '/termsAndCondition': 'light',
  '/termsOfSale/UltrahumanRing': 'light',
  '/termsOfSale/UltrahumanM1': 'light',
  '/termsOfSale/UltrahumanM2': 'light',
  '/termsOfSale/UltrahumanHome': 'light',
  '/why-ultrahuman': 'dark',
  '/how-it-works': 'light',
  // Same chrome as `/` — light theme (#111 text) plus opaque white bar
  // (`OPAQUE_LIGHT_BAR_ROUTES`). The particle card is dark; the clip-path
  // gutter around it is white, which is what the header sits on.
  '/pulsomics': 'light',
};

export const HEADER_FOOTER_V2_PAGES = [...Object.keys(headerThemeConfig)];

export const footerThemeConfig: Record<string, 'dark' | 'light'> = {
  // Add page-specific overrides here as needed
  '/home': 'dark',
  // Science is deliberately absent: every science route now ends on a light
  // band or wants one (the hub ends on Ask Our Data at #0a0a0a, where a dark
  // footer read as one unbroken slab; the white-paper detail ends on its
  // #efefef related band, where a dark footer read as a different site), so it
  // falls through to DEFAULT_FOOTER_THEME below. The matching prefix fallback
  // in Footer/FooterClient.tsx was removed with these keys — one change.
};
export const DEFAULT_FOOTER_THEME = 'light';

export const HEADER_V1_PAGES = ['/ring']; //check once

export const trackingParameters = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'affiliate',
  'affiliateCode',
  'referral',
  'discount',
  'workAffiliate',
  'heroCategory',
];
